import React,{useState,useEffect} from 'react';
import {HashRouter as Router} from 'react-router-dom';
import {motion,AnimatePresence} from 'framer-motion';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PlantManagement from './components/PlantManagement';
import EnvironmentalImpact from './components/EnvironmentalImpact';
import InverterChecks from './components/InverterChecks';
import EmailTestingDashboard from './components/EmailTestingDashboard';
import Sidebar from './components/Sidebar';
import MobileMenu from './components/MobileMenu';
import MobileHeader from './components/MobileHeader';
import {AuthProvider,useAuth} from './context/AuthContext';
import {PVDataProvider} from './context/PVDataContext';
import supabase from './lib/supabase';
import './App.css';

function AppContent() {
  const {isAuthenticated}=useAuth();
  const [currentPage,setCurrentPage]=useState('dashboard');
  const [supabaseConnected,setSupabaseConnected]=useState(false);
  const [isMobileMenuOpen,setIsMobileMenuOpen]=useState(false);

  // Check Supabase connection 
  useEffect(()=> {
    const checkConnection=async ()=> {
      try {
        const {data,error}=await supabase.from('pv_plants_a7b3c9d8e2').select('count').limit(1);
        setSupabaseConnected(!error);
        console.log('Supabase connection:',error ? 'Error' : 'Connected');
      } catch (err) {
        console.error('Supabase connection error:',err);
        setSupabaseConnected(false);
      }
    };
    checkConnection();
  },[]);

  if (!isAuthenticated) {
    return <Login />;
  }

  const renderPage=()=> {
    switch (currentPage) {
      case 'dashboard': return <Dashboard setCurrentPage={setCurrentPage} />;
      case 'plants': return <PlantManagement />;
      case 'environmental': return <EnvironmentalImpact />;
      case 'inverter-checks': return <InverterChecks />;
      case 'email-tests': return <EmailTestingDashboard />;
      default: return <Dashboard setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen bg-gray-50">
      {/* Mobile Menu */}
      <MobileMenu 
        isOpen={isMobileMenuOpen} 
        onClose={()=> setIsMobileMenuOpen(false)} 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage}
      />

      {/* Mobile Header */}
      <MobileHeader 
        onOpenMenu={()=> setIsMobileMenuOpen(true)} 
        currentPage={currentPage} 
      />

      {/* Desktop Sidebar - hidden on mobile */}
      <div className="hidden md:block">
        <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
      </div>

      <div className="flex-1 overflow-hidden">
        {!supabaseConnected && (
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  Supabase-Verbindung nicht verfügbar. Die Daten werden lokal gespeichert.
                </p>
              </div>
            </div>
          </div>
        )}

        <AnimatePresence mode="wait">
          <motion.div
            key={currentPage}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
            className="h-full overflow-auto"
          >
            {renderPage()}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <PVDataProvider>
          <AppContent />
        </PVDataProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;